import s from "./style.module.scss";
import img from "./../../assets/test.webp";
import clsx from "clsx";
import {
  Icon12ClockOutline,
  Icon12User,
  Icon24ChevronRight,
} from "@vkontakte/icons";
import { useAtom } from "@reatom/npm-react";
import { isCardViewAtom } from "../../core/reatom/state/CardView";
import { useNavigate } from "react-router";
import { memo, useMemo } from "react";
import dayjs from "dayjs";
import { StatusButton } from "./StatusButton/StatusButton";

interface CardProps {
  id: number;
  src: string | null;
  price: string;
  description: string;
  waitingTime?: number;
  lastPrice?: string;
  isCardViewProps?: boolean;
  className?: string;
  user_name?: string;
  onClick?: () => void;
  cssId?: string;
  status?:
    | "new"
    | "declined"
    | "cancelled"
    | "not_answered"
    | "accepted"
    | "work_finished"
    | "completed"
    | "fix";
}

const getDay = (waitingTime?: number) => {
  if (waitingTime == null) return null;

  const dayWord =
    waitingTime % 100 >= 11 && waitingTime % 100 <= 14
      ? "дней"
      : waitingTime % 10 === 1
      ? "день"
      : waitingTime % 10 >= 2 && waitingTime % 10 <= 4
      ? "дня"
      : "дней";

  return `${waitingTime} ${dayWord}`;
};

export const Card = memo((props: CardProps) => {
  const {
    id,
    src,
    price,
    description,
    waitingTime,
    lastPrice,
    isCardViewProps,
    className,
    user_name,
    onClick,
    cssId,
    status,
  } = props;
  const [isCardView] = useAtom(isCardViewAtom);
  const navigate = useNavigate();
  const cardView = isCardViewProps ?? isCardView;

  const day = useMemo(() => getDay(waitingTime), [waitingTime]);
  return cardView ? (
    <div
      id={cssId}
      className={clsx(s.list, className, isCardViewProps && s.isCardViewProps)}
      onClick={() => (onClick ? onClick() : navigate(`/service/${id}`))}
    >
      <div
        className={clsx(
          s.listWrapper,
          user_name && s.justify,
          status && s.status
        )}
      >
        <img src={src ?? img} alt="" className={clsx(s.img, s.listImg)} />
        <div className={clsx(s.listInnerWrapper)}>
          <div className={clsx(s.listInfo)}>
            {status && <StatusButton status={status} />}
            <div className={s.priceWrapper}>
              <p className={s.price}>{user_name ? description : price}</p>
              <p className={s.lastPrice}>{lastPrice}</p>
            </div>

            {!user_name && (
              <p className={clsx(s.descr, s.listDescr)}>{description}</p>
            )}
            <p className={s.time}>
              {user_name ? (
                <>
                  <Icon12User /> {user_name}
                </>
              ) : (
                <>
                  <Icon12ClockOutline />
                  {day}
                </>
              )}
            </p>
            {user_name && (
              <p className={s.orderTime}>
                Создан {dayjs().format("DD.MM.YYYY")}
              </p>
            )}
          </div>
          <div className={s.iconButton}>
            <Icon24ChevronRight className={s.icons} />
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div
      className={s.card}
      onClick={() => (onClick ? onClick() : navigate(`/service/${id}`))}
      id={cssId}
    >
      <img src={src ?? img} alt="" className={s.img} />
      <div className={s.info}>
        <div className={s.priceWrapper}>
          <p className={s.price}>{price}</p>
          <p className={s.lastPrice}>{lastPrice}</p>
        </div>

        <p className={s.descr}>{description}</p>
        <p className={s.time}>
          <Icon12ClockOutline />
          {day}
        </p>
      </div>
    </div>
  );
});
